import tw, { styled } from 'twin.macro';
import { BgColorHover } from 'styles/basic/BgColor';

export const StyledButton = styled(BgColorHover).attrs(
    ({ width }) => ({
        className: width ? `w-${width}` : 'w-full',
    })
)`
    ${tw`inline-flex text-base no-underline transition-colors duration-300 ease-out rounded cursor-pointer`}
    ${tw`focus:(outline-none ring-1)`}

    color: ${({ textColor }) => textColor};

    ${({ size }) => (size === 'small' ? tw`px-2` : tw`px-3 py-2`)}
`;

export const StyledButtonIcon = styled.span`
    & > *:first-child {
        ${tw`flex-shrink-0 inline-block w-4 h-4 text-2xl`}
    }
`;

export const StyledButtonLabel = styled.span`
    ${tw`inline-flex items-center justify-center w-full align-middle`}
`;
